import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition,
} from "app/library/layout-builder";
import { EventDetailProps } from "./types";
import { EventDetailPropertyDefinitions } from 'components/cms/definitions';

export class EventDetailDefinitions extends CmsReactComponent<EventDetailProps> {
    static defaultProps = {};

    static schemaName = "event-detail";

    static propertyDefinitions: PropertyDefinition[] = EventDetailPropertyDefinitions;
}
